export const adaptNavigationItem = (data: INavigationItem): NavigationItem => {
	return {
		id: data.id,
		name: data.name,
		description: data.description,
		permalink: data.permalink,
		parent: data.parent,
		url: data.url,
		web: data.web,
		webview: data.webview,
		feedId: data.feed_id ?? null,
		feed: data.feed ?? null,
		published: data.published,
		image: data.image,
		layout: data.layout,
		ordering: data.ordering,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptNavigationItems = (
	data: INavigationItem[]
): NavigationItem[] => {
	return data.map(adaptNavigationItem);
};
